import semver from 'semver';

export const carouselDefaultStyles = {
  base: {
    backGround: true,
  },
};

type TCarouselDefaultStyles = {
  backGround: boolean;
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return carouselDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return carouselDefaultStyles['1.5.0'];
  }
  //

  return carouselDefaultStyles['base'];
};
